// Import React components
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Import page components & styling
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Navbar/Footer.js';
import PrivateRoute from './api/PrivateRoutes.js';

// Import pages
import Landing from './pages/Landing.js';
import Authorization from './pages/Authorization.js';
import AdminHome from './pages/AdminHome.js'
import AdminControlPanel from './pages/AdminControlPanel.js'
import AdminAnalytics from './pages/AdminAnalytics.js'
import UserHome from './pages/UserHome.js'
import UserControlPanel from './pages/UserControlPanel.js';
import Trails from './pages/Trails.js';
import About from './pages/About.js'
import Privacy from './pages/Privacy.js'
import ResetPassword from './pages/ResetPassword.js';
import SendResetLink from './components/Form/SendResetLink.js';
import VideoPage from './pages/VideoPage.jsx';
import VideoControlPanel from './components/Admin/VideoControlPanel.js';
import ProfileControlPanel from './components/Admin/ProfileControlPanel.js';
import UserAnalytics from './components/Admin/UserAnalytics.js';
import VideoAnalytics from './components/Admin/VideoAnalytics.js';
import TrailAnalytics from './components/Admin/TrailAnalytics.js';
import TrailControlPanel from './components/Admin/TrailControlPanel.js';
import FeedbackControlPanel from './components/Admin/FeedbackControlPanel.js';
import BenchControlPanel from './components/Admin/BenchControlPanel.js';

const App = () => {
    return (
        <BrowserRouter future={{
            v7_fetcherPersist: true,
            v7_normalizeFormMethod: true,
            v7_partialHydration: true,
            v7_relativeSplatPath: true,
            v7_skipActionErrorRevalidation: true,
            v7_startTransition: true,
        }}>
            <div className="pages d-flex flex-column min-vh-100">
                <Navbar />
                <Routes>
                    {/* Public Routes */}
                    <Route path="/" element={< Landing />} />
                    <Route path="/authorization" element={< Authorization />} />
                    <Route path="/about" element={< About />} />
                    <Route path="/privacy" element={< Privacy />} />
                    <Route path="/reset/:token" element={<ResetPassword />} /> {/* Reset Password Route */}
                    <Route path="/send-reset-link" element={<SendResetLink />} /> {/* Send Reset Link Route */}

                    {/* Authorized Routes */}
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'User']} />}>
                        <Route path="/userHome" element={< UserHome />} />
                        <Route path="/userControlPanel" element={< UserControlPanel />} />
                        <Route path="/trails" element={< Trails />} />
                        <Route path="/properWalkingTechniques" element={<VideoPage subcategories={["Walking Techniques"]} title="Proper Walking Techniques"
                            description="Welcome to the Nutrition and Hydration section! Here you will find information about healthy eating, meal plans, and hydration tips." />} />
                        <Route path="/stretchesForWalking" element={<VideoPage categories={["Exercise"]} subcategories={["Stretching"]} title="Stretches For Walking"
                            description="Welcome to the Stretches For Walking library!" />} />
                        <Route path="/bodyWeightExercises" element={<VideoPage categories={["Exercise"]} subcategories={["Body Weight Exercise"]} title="Body Weight Exercises"
                            description="Welcome to the Body Weight Exercises library! This section offers a variety of instructional videos designed to help you build strength,
                            flexibility, and endurance using just your body weight. Watch, learn, and track your progress as you master each exercise." />} />
                        <Route path="/injuryPrevention" element={<VideoPage categories={["Exercise"]} subcategories={["Injury Prevention"]} title="Injury Prevention"
                            description="Welcome to the Injury Prevention library! Here, you'll find expert tips and exercises designed to help you minimize the risk of injuries
                            during workouts and physical activities. Strengthen and protect your body with these essential injury prevention techniques." />} />
                        <Route path="/nutritionandHydration" element={<VideoPage categories={["Health"]} subcategories={["Nutrition", "Hydration"]} title="Nutrition & Hydration"
                            description="Welcome to the Nutrition and Hydration section! Here you will find information about healthy eating, meal plans, and hydration tips." />} />
                    </Route>

                    {/* Admin Routes */}
                    <Route element={<PrivateRoute allowedRoles={['Admin']} />}>
                        <Route path="/adminHome" element={< AdminHome />} />
                        <Route path="/adminControlPanel" element={< AdminControlPanel />} >
                            <Route path="users" element={<ProfileControlPanel />} />
                            <Route path="videos" element={<VideoControlPanel />} />
                            <Route path="trails" element={<TrailControlPanel />} />
                            <Route path="feedback" element={<FeedbackControlPanel />} />
                            <Route path="bench" element={<BenchControlPanel />} />
                            <Route index element={<Navigate to="users" replace />} />
                        </Route>
                        <Route path="/adminAnalytics" element={< AdminAnalytics />}>
                            <Route path="users" element={<UserAnalytics />} />
                            <Route path="videos" element={<VideoAnalytics />} />
                            <Route path="trails" element={<TrailAnalytics />} />
                            <Route index element={<Navigate to="users" replace />} />
                        </Route>
                    </Route>
                </Routes>
                <Footer />
            </div>
        </BrowserRouter>
    );
}

export default App;
